import { BrandingTab } from "./BrandingTab";
import { AssetsTab } from "./AssetsTab";

/**
 * How the booth looks and sounds.
 *
 * Branding and Assets were two tabs holding one concern. Assets carried four
 * audio uploads and two copy fields — not enough to be worth a place in the tab
 * bar, and an operator styling their welcome screen had no reason to guess that
 * the sound played on that screen lived somewhere else entirely.
 *
 * Kept as two components rather than merged into one file: they're independently
 * substantial, and joining them would produce a 400-line component with no
 * benefit. The tab bar is what needed simplifying, not the code.
 */
export function LookTab() {
  return (
    <div className="flex flex-col gap-8">
      <BrandingTab />
      <AssetsTab />
    </div>
  );
}
